/**
 * API Configuration Utility
 * Ensures API URLs use HTTPS when the page is loaded over HTTPS
 * to prevent mixed content errors.
 */

/**
 * Get the API base URL, ensuring HTTPS when page is loaded over HTTPS
 * @returns {string} The API base URL with correct protocol
 */
export function getApiBaseUrl() {
  let apiUrl = process.env.REACT_APP_API_BASE_URL || '';
  
  // If no API URL is set, return empty string (will use relative URLs)
  if (!apiUrl) {
    return '';
  }
  
  // Check if we're in a browser environment and page is loaded over HTTPS
  if (typeof window !== 'undefined' && window.location && window.location.protocol === 'https:') {
    const hostname = window.location.hostname;
    const isNgrok = hostname.includes('ngrok') || hostname.includes('ngrok-free.dev') || hostname.includes('ngrok.io');
    
    // If on ngrok and API URL is localhost, use relative URLs
    // The React dev server proxy (configured in package.json) will handle forwarding to backend
    if (isNgrok && apiUrl.includes('localhost')) {
      console.warn(`[API Config] Using relative URLs for API calls when accessed via ngrok. 
        Make sure your React dev server proxy is configured to forward /api/* to http://localhost:8000`);
      // Return empty to use relative URLs - React proxy will forward to backend
      return '';
    }
    
    // If page is HTTPS and API URL is HTTP, convert to HTTPS (only for non-localhost)
    if (apiUrl.startsWith('http://') && !apiUrl.includes('localhost')) {
      apiUrl = apiUrl.replace('http://', 'https://');
      console.warn(`[API Config] Converted HTTP API URL to HTTPS: ${apiUrl}`);
    }
  }
  
  return apiUrl;
}

// Export a constant for backward compatibility
// Note: This is evaluated at module load time, which is fine for browser-based React apps
export const API_BASE_URL = getApiBaseUrl();

